
type JumpQuery = {
  original_referrer: string;
  came_from: string;
};

let jumpQuery: JumpQuery | undefined = undefined;

export const getJumpQuery = () => {
  if (!jumpQuery) {
    jumpQuery = {
      original_referrer: getQueryParam('referrer'),
      came_from: getQueryParam('came_from'),
    };

    removeUrlParameterFromAddressBar(['referrer', 'came_from']);
  }

  return jumpQuery;
};

export const getQueryParam = (key: string) => {
  try {
    return (
      new URLSearchParams(decodeURIComponent(window.location.search)).get(
        key,
      ) || ''
    );
  } catch (e) {
    const reg = new RegExp(`[?&]${key}=([^&]*)`);
    const search = decodeURIComponent(window.location.search);
    const match = search.match(reg);
    return (match ? match[1] : null) || '';
  }
};

export const removeUrlParameterFromAddressBar = (params: string[]) => {
  const url = new URL(window.location.href);

  params.forEach((p) => {
    url.searchParams.delete(p);
  });

  window.history.replaceState(null, '', url.toString());
};